import { render } from "./LinkWithIcon.vue?vue&type=template&id=723ddecc&scoped=true"
import script from "./LinkWithIcon.vue?vue&type=script&lang=js"
export * from "./LinkWithIcon.vue?vue&type=script&lang=js"

import "./LinkWithIcon.vue?vue&type=style&index=0&id=723ddecc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723ddecc"]])

export default __exports__